<div class="mfunsPlayer-episode-mask">
    <div class="mfunsPlayer-episode-list">
        {{ each $data }}
        <div class="mfunsPlayer-episode-item">{{ $value.title }}</div>
        {{ /each }}
    </div>
</div>